import HeaderFive from './component.styles'
export default HeaderFive
